/**
 * Extract the first interactive HTML artifact from an assistant
 * message. Recognises:
 *   1. ```html / ```HTML fenced code blocks (preferred — Claude-style)
 *   2. A full document starting with `<!DOCTYPE html>` or `<html ...>`
 * Returns `{ html, title } | null`. The title is heuristically pulled
 * from the first <h1> / <title> tag or falls back to "HTML Artifact".
 */
export function extractHtmlArtifact(text) {
  if (!text || typeof text !== 'string') return null;

  // 1) fenced ```html block
  const fence = /```(?:html|HTML)\s*\n([\s\S]*?)\n```/m.exec(text);
  let html = fence ? fence[1] : null;

  // 2) raw <!doctype html> / <html> block
  if (!html) {
    const doc = /(<!doctype html>[\s\S]*?<\/html>|<html\b[\s\S]*?<\/html>)/i.exec(text);
    if (doc) html = doc[1];
  }
  if (!html || html.length < 30) return null;  // ignore tiny snippets

  // Heuristic title
  let title = null;
  const t1 = /<title>([^<]+)<\/title>/i.exec(html);
  if (t1) title = t1[1].trim();
  if (!title) {
    const h1 = /<h1[^>]*>([^<]+)<\/h1>/i.exec(html);
    if (h1) title = h1[1].trim();
  }
  return { html, title: title || 'HTML Artifact' };
}

/** Quick boolean check used by the chat bubble to decide whether to
 * show the "Open Preview" CTA. */
export function hasHtmlArtifact(text) {
  return !!extractHtmlArtifact(text);
}
